import React from "react";
import styled from "@emotion/styled";
import ParkkiTheme from "themes/ParkkiTheme";

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex: 1;
  width: 100%;
  height: 26px;
  padding-right: ${ParkkiTheme.spacings.base};
  padding-left: ${ParkkiTheme.spacings.base};
`;

const PercentageContainer = styled.div`
  height: 100%;
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: ${ParkkiTheme.colors.white};
  margin-left: ${(props: { right?: boolean }) =>
    props.right ? "23px" : "0px"};
`;

const CircleContainer = styled.div`
  height: 20px;
  width: 26px;
  border-radius: 50%;
  background-color: ${ParkkiTheme.colors.green};
`;

const LeftCircleContainer = styled(CircleContainer)`
  margin-right: -13px;
`;

const CenterCircleContainer = styled(CircleContainer)`
  margin-left: -13px;
  z-index: 3;
`;

const RightCircleContainer = styled(CircleContainer)`
  margin-left: -13px;
  background-color: ${ParkkiTheme.colors.flatRed};
`;

const LeftContainer = styled.div`
  height: 100%;
  min-width: 25px;
  background-color: ${ParkkiTheme.colors.green};
  z-index: 4;
  width: ${(props: { width: number }) => `${props.width}%`};
`;

const RightContainer = styled.div`
  height: 100%;
  min-width: 50px;
  width: ${(props: { width: number }) => `${props.width}%`};
  background-color: ${ParkkiTheme.colors.flatRed};
  margin-left: -13px;
  z-index: 2;
`;

type Content = {
  percentage: number;
  value: number;
};

type Props = {
  leftContent: Content;
  rightContent: Content;
  byPercentage: boolean;
};

function LinePercentage({
  leftContent,
  rightContent,
  byPercentage = true,
}: Props): JSX.Element {
  const getLabel = (value: Content) => {
    return byPercentage ? `${value.percentage} %` : value.value;
  };

  return (
    <Container>
      <LeftCircleContainer />
      <LeftContainer width={leftContent.percentage}>
        <PercentageContainer>{getLabel(leftContent)}</PercentageContainer>
      </LeftContainer>
      <CenterCircleContainer />
      <RightContainer width={rightContent.percentage}>
        <PercentageContainer right>
          {getLabel(rightContent)}
        </PercentageContainer>
      </RightContainer>
      <RightCircleContainer />
    </Container>
  );
}

export default LinePercentage;
